import { z } from 'zod'

import { Client } from '@/types/park/client'
import { Manager, ManagerBinding } from '@/types/park/manager'

/** User profile information returned by /me endpoint */
export const User = z.object({
    id: z.number(),
    client: ManagerBinding,
    first_name: z.string().min(1),
    last_name: z.string().min(1).toUpperCase(),
    email: z.string().email(),
    origin_of_creation: z.string(),
    creation_date: z.string().date(),
    fidelity_point: z.number(),
    credit: z.number(),
    id_badge: z.string(),
    max_number_discount: z.number(),
    phone: z.string().optional(),
    nb_discount_used: z.number(),
    card_id: z.string(),
    activation_key: z.string(),
    activation_key_expires: z.string(),
    avatar: z.string().optional(),
    receive_newsletter: z.boolean(),
    receive_discount: z.boolean(),
    receive_publicity: z.boolean(),
    pspReference: z.string().optional(),
    recurringDetailReference: z.string().optional(),
    reset_password_code: z.string().optional(),
    reset_password_code_expires_at: z.string().optional(),
    automatic_payment_threshold: z.number().optional(),
    site_customer: Client.pick({
        id: true,
        name: true,
    }).optional(),
    service: z.number(),
})

export type User = z.infer<typeof User>

/** Konvive user that replace userAtom*/
export const KonviveUser = z.object({
    id: z.number().positive(),
    firstName: z.string().min(1),
    credit: z.number().positive(),
    cardId: z.number(),
    client: Manager.shape.id,
    site_customer: Client.shape.id,
})

export type KonviveUser = z.infer<typeof KonviveUser>

export const UserUpdatePayload = User.pick({
    email: true,
    first_name: true,
    last_name: true,
    phone: true,
    receive_discount: true,
    receive_newsletter: true,
    receive_publicity: true,
})

export type UserUpdatePayload = z.infer<typeof UserUpdatePayload>

export const UpdatePasswordPayload = z.object({
    old_password: z.string(),
    new_password: z.string(),
})

export type UpdatePasswordPayload = z.infer<typeof UpdatePasswordPayload>

export const UpdatePasswordResponse = z.object({
    old_password: z.string().optional(),
    new_password: z.string().optional(),
})

export type UpdatePasswordResponse = z.infer<typeof UpdatePasswordResponse>
